module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/kontakt"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone fa-fw"
  }), _vm._v(" Kontakt os\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d5eb2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/contact-cta.vue
// module id = 269
// module chunks = 1